import { store } from './store';  // Import the same Vuex store

export default class CompareProducts {

    constructor() {
        // Set initial state of compared items in localStorage
        if (typeof localStorage.compare_items === 'undefined') {
            localStorage.compare_items = [];
        }

        if (typeof Vue !== 'undefined' && typeof localStorage !== 'undefined') {
            this.startApp();
        }
    }

    /**
     * Add an item to the drawer via localStorage
     * @param item
     * @param type
     */
    static addItem(item) {
        let items = [];
        let newItem = {
            type: item.type
        };

        // Collect existing items
        if (localStorage.compare_items) {
            items = JSON.parse(localStorage.compare_items);
        }

        // Show lightbox if they have more than 4 selected
        if (items.length >= 4) {
            $.featherlight("<h4 style='margin:0;text-align:center;'>That's too many!</h4><p>You can only compare up to 4 pieces of equipment at a time.</p>");
            return false;
        }

        // Create item data
        if (item.type === 'new') {
            newItem.image = item.primary_image_url;
            newItem.link = window.location.origin+'/products/new/'+item.sku;
            newItem.title = 'John Deere ' + item.model_number;
            newItem.id = item.sku;
        } else if (item.type === 'used') {
            newItem.image = item.primary_image_url;
            newItem.link = window.location.origin+'/products/used/'+item.machine_id;
            newItem.title = item.model_info;
            newItem.id = item.machine_id;
        }

        if (!newItem.image) {
            newItem.image = item.image;
        }

        // Add item to localStorage
        items[items.length] = newItem;
        localStorage.compare_items = JSON.stringify(items);
        $(document).find($("#compare-drawer")).addClass('open');
    }

    /**
     * Remove an item from the drawer based on the index
     * @param index
     */
    static removeItem(index) {
        let items = [];
        if (localStorage.compare_items.length > 0) {
            items = JSON.parse(localStorage.compare_items);
            items = items.splice(index, 1);
            localStorage.setItem('compare_items', JSON.stringify(items));
        }
    }

    /**
     * VueJS app to handle getting, removing and opeing drawer/items
     */
    startApp() {
        let _this = this;

        this.app = new Vue({
            el: "#compare-drawer",
            store,
            data() {
                return {
                    items: []
                }
            },
            mounted() {
                this.items = this.getItems();
                if (typeof this.items === 'undefined') {
                    this.items = [];
                }
            },
            methods: {
                /**
                 * Get all the localStorage items every second - we use a setInterval here
                 * to act like a "reactive" property. localStorage isn't a reactive property natively.
                 */
                getItems() {
                    let self = this;
                    setInterval(function() {
                        if (localStorage.compare_items.length > 0) {
                            self.items = JSON.parse(localStorage.getItem('compare_items'));
                        }
                    }, 1000);
                },

                /**
                 * Remove an item from the drawer & localStorage
                 * @param index
                 */
                removeItem(index) {
                    let items = [];
                    if (localStorage.compare_items.length > 0 && index > -1) {
                        items = JSON.parse(localStorage.compare_items);
                        items.splice(index, 1);
                    }
                    if (items.length <= 0) { items = []; }
                    localStorage.setItem('compare_items', JSON.stringify(items));
                },

                /**
                 * Open/Close the drawer
                 */
                open() {
                    $('#compare-drawer').toggleClass('open');
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./resources/js/CompareProducts.js